import { onDocumentReady, Carousel, Slider } from "@story/story_assets";
// import { onCookiesConsentReady } from "@story/story_cookies_consent";

import "@story/story_assets/slide";

import "@story/story_assets/modal/modal";
import "@story/story_assets/modal/modal_dialog";
import "@story/story_assets/modal/modal_gallery";

import "@story/story_assets/recaptcha";
import "@story/story_assets/ajax_form";

// import "@story/story_cookies_consent/cookies_consent_link";
// import "@story/story_cookies_consent/cookies_consent_modal";

import "./components/forms";
import "./components/shipping";
import "./components/variable_fields";

onDocumentReady(function() {
	for (const element of document.querySelectorAll(".carousel")) {
		new Carousel(element);
	}

	for (const element of document.querySelectorAll(".slider")) {
		new Slider(element);
	}
});



// onCookiesConsentReady(function(allowed, changes) {
// 	const consents = {
// 		ad_storage: "denied",
// 		ad_personalization: "denied",
// 		ad_user_data: "denied",
// 		analytics_storage: "denied"
// 	}

// 	if (allowed.includes("marketing")) {
// 		consents["ad_storage"] = "granted";
// 		consents["ad_personalization"] = "granted";
// 		consents["ad_user_data"] = "granted";
// 	}

// 	if (allowed.includes("analytic")) {
// 		consents["analytics_storage"] = "granted"
// 	}

// 	window.dataLayer.push(["consent", "update", consents]);
// });